import './LoadingSpinner.css';

function LoadingSpinner() {
  return (
    <div className="loading-spinner">
      <div className="loading-spinner__circle1"></div>
      <div className="loading-spinner__circle2"></div>
    </div>
  );
}

export default LoadingSpinner;
